import type { AdminAccountPaymentSummaryAppGroupSummariesItem } from './adminAccountPaymentSummaryAppGroupSummariesItem';

export interface AdminAccountPaymentSummaryAppGroup {
  activeSubscriptionCount: number;
  appKey: string;
  appLabel: string;
  /** 첫 로그인 및 추천인 쿠폰을 제외한 운영 쿠폰 누적 사용 개수 */
  couponUsageCount?: number;
  /** 첫 로그인 및 추천인을 제외한 운영 쿠폰 사용 또는 기간 지급 시각 */
  couponUsageDates: string[];
  /**
   * 현재 이용 구간을 만든 쿠폰 코드, 혜택 캠페인 ID 등의 식별자
   * @nullable
   */
  currentAccessReference?: string | null;
  /** 현재 이용 구간의 실제 출처 (NONE, PAID_SUBSCRIPTION, STORE_SUBSCRIPTION, STORE_OFFER_TRIAL, COUPON, REFERRAL_COUPON, REFERRAL_REWARD, FIRST_LOGIN_BENEFIT, MANUAL_BENEFIT, OTHER_BENEFIT) */
  currentAccessSource: string;
  /**
   * 현재 이용 구간을 만든 결제 또는 혜택 발생 시각
   * @nullable
   */
  currentAccessStartedAt?: string | null;
  /** 첫 로그인 혜택 발생 시각 */
  firstLoginBenefitActivityDates: string[];
  /**
   * 가장 최근에 사용한 쿠폰 코드
   * @nullable
   */
  latestCouponCode?: string | null;
  /**
   * 가장 최근 쿠폰이 지급한 체험 일수
   * @nullable
   */
  latestCouponTrialDays?: number | null;
  /**
   * 가장 최근에 사용한 쿠폰 유형
   * @nullable
   */
  latestCouponType?: string | null;
  /**
   * 가장 최근 쿠폰 사용 시각
   * @nullable
   */
  latestCouponUsedAt?: string | null;
  /** 운영자 수동 혜택 지급 시각 */
  manualBenefitActivityDates: string[];
  /**
   * 다음 결제 또는 스토어 이용 종료 기준 시각
   * @nullable
   */
  nextPaymentAt?: string | null;
  /**
   * 다음 결제를 관리하는 플랫폼
   * @nullable
   */
  nextPaymentPlatform?: string | null;
  /**
   * 다음 결제 판별 상태 (SCHEDULED, STORE_AUTORENEWING, STORE_NOT_RENEWING, STORE_STATUS_UNKNOWN, PAYMENT_FAILURE, NONE)
   * @nullable
   */
  nextPaymentState?: string | null;
  /**
   * 스토어가 실제 구매에 적용했다고 응답한 offer ID
   * @nullable
   */
  offerId?: string | null;
  /**
   * Offer를 검증한 결제 플랫폼
   * @nullable
   */
  offerPlatform?: string | null;
  /** 스토어 Offer 무료체험 시작 시각 */
  offerTrialActivityDates: string[];
  /**
   * 스토어가 무료체험 상태로 검증한 구간의 종료 시각
   * @nullable
   */
  offerTrialEndsAt?: string | null;
  /** 스토어 구매 검증 기반 Offer 무료체험 상태 (ACTIVE, ENDED, OFFER_APPLIED, NONE). 기존 이력은 추정하지 않음 */
  offerTrialState: string;
  /** Play 또는 비스토어 PG에서 결제 수신이 확인된 구독 활동 시각 */
  paidSubscriberActivityDates: string[];
  /** 추천인 직접 보상 또는 추천인 쿠폰 기간 지급 시각 */
  referralRewardActivityDates: string[];
  /** Google Play 구매 검증 활동 시각. 실제 청구액 확정 통계와 분리함 */
  storeSubscriptionActivityDates: string[];
  summaries: AdminAccountPaymentSummaryAppGroupSummariesItem[];
}
